import React, { useEffect, useState, useRef } from 'react';
import './index.css';
import { isDev } from '../../index';

interface Item {
  id: string;
  featured_image: {
    url: string;
    alt: string;
  };
  title: string;
}

interface ErrorData {
  description: string;
}

interface SuccessData {
  items: Item[];
}

interface PopupProps {
  popupTitle?: string;
  onClose: () => void;
  data: ErrorData | SuccessData;
}

const Popup: React.FC<PopupProps> = ({ onClose, popupTitle, data }) => {
  const [isVisible, setIsVisible] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);

  const host = isDev ? 'http://localhost:3000' : 'https://enda-combine-stock-shopify-app.web.app';

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setIsVisible(false);
        onClose();
      }
    };

    const handleScroll = () => {
      setIsVisible(false);
      onClose();
    };

    document.addEventListener('mousedown', handleOutsideClick);
    // window.addEventListener('scroll', handleScroll);

    setTimeout(() => {
      setIsVisible(true);
    }, 10);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      // window.removeEventListener('scroll', handleScroll);
    };
  }, [onClose]);

  const handleViewCart = () => {
    window.location.href = '/cart';
    onClose();
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  const defaultTitle = data && 'items' in data && data.items.length > 1 ? 'Products' : 'Product';

  return (
    <div
      className={`rp-popup-container ${isVisible ? 'visible' : ''}`}
      onAnimationEnd={handleClose}
      ref={popupRef}
    >
      <div className="rp-popup-content">
        {!('items' in data) ? (
          <>
            <div>
              <div>
                <div className="rp-popup-header">
                  <div className="rp-popup-icon">
                    <img src={`${host}/assets/icons/danger.png`} alt="warning" width={50} />
                  </div>
                  <p className="rp-popup-subtitle">
                    {(data as ErrorData)?.description || 'Product is not available'}
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div>
              <div>
                <div className="rp-popup-header">
                  <h6 className="rp-popup-title">
                    {popupTitle || defaultTitle} has been added to your cart
                  </h6>
                </div>
                <div className="rp-popup-items">
                  {(data as SuccessData).items.map((item) => (
                    <div key={item.id} className="rp-popup-product-container">
                      <img
                        src={item.featured_image.url}
                        alt={item.featured_image.alt}
                        className="rp-popup-image"
                      />
                      <div>
                        <p className="rp-popup-product-title">{item.title}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="rp-popup-buttons">
                <button className="rp-buttons rp-popup-button button altcolour rp-popup-buttons-keep-shop" onClick={handleClose}>
                  Keep Shopping
                </button>
                <button className="rp-buttons rp-popup-button rp-popup-buttons-go-to-cart" onClick={handleViewCart}>
                  View Cart
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Popup;
